import { ConnectorRepo } from '@core/repositories'
const resource = "/connection";
export default {
  getStickyNotes(type, params = {}) {
		return ConnectorRepo.get(`${resource}/${type}/sticky_notes`, { params })
	},
	addStickyNote(payload, config = {}) {
		return ConnectorRepo.post(`${resource}/neto/add_sticky_note`, payload)
	}
}